import { useQuery } from '@tanstack/react-query';

import { getCampaigns } from '../api/ventura/contract';
import { camelCaseKeys } from '../util/object';
import { useConfig } from './useConfig';

// The CONTRACT-nested campaigns index opts into the per-domain flip via
// apiHostFor('contractReports') — ACH serves this route as of ACH-r8vb, and
// contractReports is now in ACH_MIGRATED_DOMAINS, so this resolves to ACH wherever the
// env gate is open (QA by default; a local dev build must turn achBackendEnabled on for
// the session). No response adaptation: both consumers read the
// `collection` array only (ContractAdGroups.tsx:49, ContractTargetedCreatives.tsx:27)
// and neither reads the pagination meta, so RD-3's meta differences are invisible
// here.
function useContractCampaigns(contractId: number) {
  const { apiHostFor } = useConfig();
  const contractReportsHost = apiHostFor('contractReports');

  const query = useQuery({
    queryKey: ['contractCampaigns', contractId],
    queryFn: () => getCampaigns(contractReportsHost, contractId),
    select: camelCaseKeys
  });

  return query;
}

export default useContractCampaigns;
